import { CATEGORY_RANKING_FREQUENCY, CATEGORY_RANKING_TYPE } from '@/utils/category-ranking'
import maDate from '@/base/MaDate'
import { OVERALL_CATEGORY_IOS_ID, OVERALL_FAMILY_AGE_PLAY_ID } from '@/base/constants/category-id'

export const SAFE_VALUES = Object.freeze({
  trackId: '571800810',
  trackIds: ['571800810'],
  publisherId: '571800813',
  activeApp: '571800810',
  countryCode: 'US',
  countryCodes: ['US'],
  cppFilter: 'all',
  store: 'ios',
  device: 'iphone',
  categoryId: OVERALL_CATEGORY_IOS_ID,
  rankingType: CATEGORY_RANKING_TYPE.FREE,
  rankingFrequency: CATEGORY_RANKING_FREQUENCY.DAILY,
  ageId: OVERALL_FAMILY_AGE_PLAY_ID,
  categories: [OVERALL_CATEGORY_IOS_ID],
  sortType: 'normal',
  startDate: maDate().formatISODate(),
  endDate: maDate().formatISODate(),
  date: maDate().formatISODate(),
  selectedDate: maDate().formatISODate(),
  chartScale: 'linear',
  chartDataMode: 'opt-in',
  languageCode: 'EN',
  keyword: 'workout',
  keywords: ['game'],
  year: maDate().subtract(1, 'month').year(),
  month: maDate().subtract(1, 'month').subtract(2, 'days').month() + 1,
  appUpdateTypes: ['Average Rating'],
  categoryType: 'Overall',
  videoFilter: 'all',
  developerName: 'Good Job Games',
  adNetwork: 'all',
  countryFilter: 'US',
  competitorGroupId: 'ALL',
  productFamily: 'ASO',
})
